import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'poAmount'
})
export class PoAmountPipe implements PipeTransform {

  transform(value: any): any {
    let cnt = 0;
    if(value.slabCount) {
      cnt = parseInt(value.slabCount);
    }
    let cost = 0;
    if(value.price.slab) {
      cost = parseFloat(value.price.slab);
    }

    return (cnt * cost).toFixed(2);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/po-amount-pipe.ts